import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import theme from '../../../styled/theme'
import { Section, SectionHeader, SectionTitle } from '../../../styled/sections'
import { Text2 } from '../../../components/ui/text'
import { Button } from '../../../components/ui/button'
import Filter from '../../../assets/icons/filter'
import ModalFilter from '../../../components/ModalFilter'
import { clinics } from '../../../constants/mockClinics'
import { resetLabsFilters, setLabsFilters } from '../../../actions/filterLaboratory'
import { selectLabsFilters, selectLabsFiltersCount } from '../../../reducers/filterLaboratory'
import Pagination from '../../../components/pagination'
import { useLabResultsData } from '../../../hooks/useLabResultsData'
import LabResultsSection from '../../../components/LabResultsSection'

const inFlightInitialLabFetchByKey = {}

function LaboratoryResults({ filtersCount, filters, setLabsFilters, patient,auth }) {
	const { data, totalPages, currentPage, loading, error, fetchData } = useLabResultsData()

	useEffect(() => {
		if (!patient?.pacienteERID || (data && data.length > 0)) return

		const request = {
			currentPage: filters.currentPage || 1,
			itemsPerPage: filters.itemsPerPage || 10,
			clinic: filters.clinic,
			order: filters.order,
			fecha: filters.fecha,
			patientERID: patient.pacienteERID,
			sortBy: filters.sortBy
		}

		const requestKey = JSON.stringify(request)

		if (!inFlightInitialLabFetchByKey[requestKey]) {
			inFlightInitialLabFetchByKey[requestKey] = fetchData(request).finally(() => {
				delete inFlightInitialLabFetchByKey[requestKey]
			})
		}
	}, [
		data,
		fetchData,
		filters.clinic,
		filters.currentPage,
		filters.fecha,
		filters.itemsPerPage,
		filters.order,
		filters.sortBy,
		patient?.pacienteERID
	])

	const labResultsList = data
	const [showModal, setShowModal] = useState(false)
	const hasActiveFilters = Boolean(
		filters?.clinic || filters?.order || filters?.date || filters?.fecha || filters?.nOrder
	)

	const handleFilters = () => {
		setShowModal(true)
	}

	const handlePageChange = page => {
		const newFilters = { ...filters, currentPage: page, patientERID: patient?.pacienteERID }
		setLabsFilters(newFilters)
		fetchData({
			...newFilters,
			nOrder: filters.order
		})
	}

	return (
		<div style={{ width: '100%' }}>
			<Section gap="32px">
				<SectionHeader align={'flex-start'} gap="8px">
					<SectionTitle mbDesktop="0px">Resultados de laboratorio</SectionTitle>
					<Text2 color={theme.colors.text.secondaryText}>
						Descargá los informes de tus estudios de laboratorio.
					</Text2>
				</SectionHeader>
				<SectionHeader align={'flex-start'}>
					<Button
						color={theme.colors.text.secondaryText}
						$variant={'cardNav'}
						iconLeft={<Filter />}
						label={`Filtros ${filtersCount > 0 ? `(${filtersCount})` : ''}`}
						onClick={handleFilters}
					/>
				</SectionHeader>
			</Section>
			<ModalFilter
				clinics={clinics}
				showModal={showModal}
				onClose={() => setShowModal(false)}
				initialFilters={filters}
				onApplyFilters={values => {
					const newFilters = {
						...values,
						currentPage: 1,
						itemsPerPage: filters.itemsPerPage || 10,
						patientERID: patient.pacienteERID
					}
					setLabsFilters(newFilters)
					fetchData({
						...newFilters
					})
					setShowModal(false)
				}}
			/>

			<Section>
				<LabResultsSection
					isCarousel={false}
					hasActiveFilters={hasActiveFilters}
					loading={loading}
					error={error}
					paginatedResults={labResultsList}
					isHome={false}
				/>
			</Section>
			<Pagination
				totalPages={totalPages}
				currentPage={currentPage}
				onPageChange={handlePageChange}
			/>
		</div>
	)
}

const mapStateToProps = ({ patient, filterLaboratory, auth }) => ({
	filters: selectLabsFilters(filterLaboratory),
	filtersCount: selectLabsFiltersCount(filterLaboratory),
	patient,
	auth
})

const mapDispatchToProps = {
	setLabsFilters,
	resetLabsFilters
}

export default connect(mapStateToProps, mapDispatchToProps)(LaboratoryResults)
